import React, { Component } from 'react';
import {actions, connect} from 'mirrorx';

import { slide as Menu } from 'react-burger-menu'
import './filebar.css';

import LocalhostController from '../controllers/localhost-controller';
import DropboxController from '../controllers/dropbox-controller';

import OverwriteFileModal from './overwrite-file-modal';

import FileProviders from '../enums/file-providers';

import isEqual from 'lodash.isequal';

class Filebar extends Component {

	constructor() {
		super();
		this.controller = new LocalhostController();
    this.dbcontroller = null;

    this.file = {
      path: null,
      name: null,
      service: null
    }

    this.renderRecentItem = this.renderRecentItem.bind(this);
	}


	componentDidMount() {
		this.controller.loadRecentPaths().then(paths => {
      paths = paths || [];
			actions.autosave.updateRecentPaths(paths);
		});
    this.dbcontroller = new DropboxController(this.props.services.dropboxClientId);
	}

  handleOpenRecentFile = (item) => {
    this.file = {
      path: item.path,
      name: item.name,
      service: item.service
    };

    if (this.props.editor.isDirty) {
      return this.refs.overwriteModal.activateModal();
    }
    else {
      return this.openFile();
    }
  }

  componentWillReceiveProps(newProps) {
    if (!isEqual(this.props.autosave.recentPaths, newProps.autosave.recentPaths)) {
      this.controller.saveRecentPaths(newProps.autosave.recentPaths);
    }
   
  }

  openFile = () => {
    this.dbcontroller.loadFromDropbox(this.file.path, this.file.name).then(meta => {
      actions.autosave.addRecentPath({
        name: meta.name,
        path: meta.path,
        service: FileProviders.DROPBOX
      });
    });
  }

  renderRecentItem(item) {
    return <div className='recent-item'>
      <div className='recent-item-name' onClick={() => this.handleOpenRecentFile(item)}>{item.path}{item.name}</div>
      <button className='recent-item-kill btn' onClick={() => {
        actions.autosave.removeItem(item);
      }}><i className='icon-trash' /></button>
    </div>;
  }
	
	render () {
  	return (
    	<Menu right 
    		customBurgerIcon={ <img src="/img/e.svg" alt="Open right sidebar" /> }
    		isOpen={this.props.layout.filebar.open}>
      	<h2>Recent Files</h2>
      	{this.props.autosave.recentPaths.map((item) => {
  				return this.renderRecentItem(item);
  			})}
        <OverwriteFileModal ref='overwriteModal' 
          name={this.file.name} 
          path={this.file.path} 
          service={this.file.service}
          onClick={this.openFile}
          customText={'Discard changes to '+this.file.path+this.file.name+'?'}/>
    	</Menu>
  );
  }
}

export default connect(state => {
  return {layout: state.layout,
    editor: state.editor,
  	services: state.services,
  	autosave: state.autosave}
})(Filebar)


// WEBPACK FOOTER //
// ./src/components/filebar.js